import { render } from "./SimpleTrigger.vue?vue&type=template&id=6f297e3e"
import script from "./SimpleTrigger.vue?vue&type=script&lang=js"
export * from "./SimpleTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script